import React, { useState, useEffect } from 'react'

import { getFractionDigit, parseNumber } from 'utils'

interface IProps {
  name: string
  defaultValue: string | undefined
  min?: number
  max?: number
  unit?: string
  className?: string
  placeholder: string | undefined
  hideUnit?: boolean
  rightAlign?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  onBlur?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const NumberInput: React.FC<IProps> = (props) => {
  const {
    defaultValue,
    onChange,
    onBlur,
    name,
    unit,
    className,
    placeholder,
    rightAlign,
    hideUnit,
    min,
    max,
  } = props
  const [value, setValue] = useState<string>(parseNumber(defaultValue, unit))
  const [valueChanged, setValueChanged] = useState<string>(parseNumber(defaultValue, unit))

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target
    setValue(value)

    if (onChange) {
      onChange(e)
    }
  }

  useEffect(() => {
    const defaultValueParsed = parseNumber(defaultValue, unit)

    if (defaultValueParsed !== value) {
      setValue(defaultValueParsed)
    }
    // eslint-disable-next-line
  }, [defaultValue, unit])

  const getStep = () => {
    const fractionDigit = getFractionDigit(unit)

    if (fractionDigit > 0) {
      return `0.${'0'.repeat(getFractionDigit(unit) - 1)}1`
    }

    return '1'
  }

  return (
    <div className={`${!hideUnit && !rightAlign && 'w-6/12'}`}>
      <input
        type="number"
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={(e) => handleChange(e)}
        onBlur={(e: any) => {
          // Fixes moz onBlur issue
          if (
            e.nativeEvent.explicitOriginalTarget &&
            e.nativeEvent.explicitOriginalTarget === e.nativeEvent.originalTarget
          ) {
            return
          }

          setValue(parseNumber(value, unit))

          if (onBlur && value !== valueChanged) {
            onBlur(e)
            setValueChanged(parseNumber(value, unit))
          }
        }}
        className={className}
        min={min}
        max={max}
        step={getStep()}
        lang="de-DE"
      />
    </div>
  )
}

export default NumberInput
